// Swap LOGO_SRC with the client's logo file (e.g. "/logo.png") once provided
const LOGO_SRC = null;

export const Logo = ({ className = "" }) => (
  <a href="#top" data-testid="brand-logo" className={`flex items-center gap-3 ${className}`}>
    {LOGO_SRC ? (
      <img src={LOGO_SRC} alt="Core Websites logo" className="h-10 w-auto" />
    ) : (
      <svg viewBox="0 0 64 64" className="h-10 w-10" aria-label="Core Websites logo">
        <rect width="64" height="64" rx="14" fill="#0A1128" />
        <rect x="1" y="1" width="62" height="62" rx="13" fill="none" stroke="#3B82F6" strokeOpacity=".5" strokeWidth="2" />
        <path d="M42 20a16 16 0 1 0 0 24" fill="none" stroke="#F8FAFC" strokeWidth="6" strokeLinecap="round" />
        <circle cx="32" cy="32" r="5" fill="#38BDF8" />
      </svg>
    )}
    <span className="font-display text-lg font-semibold tracking-tight text-white">
      Core <span className="font-light text-sky-300">Websites</span>
    </span>
  </a>
);
